
import { Vue, prop, Options } from "vue-class-component";
import {
  DetailPartnerAreaDedicated,
  GeoAddressArea,
  DetailShifts,
  GeoAddress
} from "@/domain/entities/ManageArea";
import AreaNameInput from "../area-name-input/index.vue";
import { ManageAreaController } from "@/app/ui/controllers/ManageAreaController";
import {
  AvailableGeoAddressApiRequest,
  UpdatePartnerAreaRequest,
  ListGeoAddressApiRequest
} from "@/data/payload/api/ManageAreaApiRequest";
import GeoAddressTreeSelector from "../geo-address-tree-selector/index.vue";
import AssignCourier from "../assign-courier/index.vue";
import DynamicShift from "../dynamic-shift/index.vue";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { PaginationV2 } from "@/domain/entities/Pagination";

class Props {
  modelValue = prop<boolean>({
    default: false,
    type: Boolean,
    required: true
  });
  data = prop<DetailPartnerAreaDedicated>({
    default: () => new DetailPartnerAreaDedicated(),
    type: Object
  });
  unassigned = prop<number>({
    default: 0
  });
}

@Options({
  components: {
    AreaNameInput,
    GeoAddressTreeSelector,
    AssignCourier,
    DynamicShift
  },
  watch: {
    modelValue(newVal: boolean) {
      if (newVal) this.init();
    }
  }
})
class ModalEditArea extends Vue.with(Props) {
  form = new DetailPartnerAreaDedicated();
  geoAddress: GeoAddressArea[] = [];
  isShiftEnabled = false;
  selectedCourier: any = "";
  isNotErrorShift = false;
  nameValidationError = true;
  geoAddressIds: GeoAddress[] = [];
  existingShift: DetailShifts[] = [];

  init() {
    this.form = this.data;
    this.isShiftEnabled = this.form.shifts.length > 1;
    this.selectedCourier =
      this.form.shifts.length > 1
        ? ""
        : {
            id: this.form.shifts[0].courierId,
            displayName: `[${this.form.shifts[0].courierId}] ${this.form.shifts[0].courierName}`
          };
    this.fetchAvailableGeoAddress();
    this.fetchGeoAddress();
    this.existingShift = this.form.shifts.length > 1 ? this.form.shifts : [];
  }

  get visible() {
    return this.modelValue;
  }
  set visible(val: boolean) {
    this.$emit("update:modelValue", val);
  }

  async fetchAvailableGeoAddress() {
    this.geoAddress = await ManageAreaController.getAvailableGeoAddress(
      new AvailableGeoAddressApiRequest({
        excludeAreaUid: this.form.uid
      })
    );
  }

  async fetchGeoAddress() {
    this.geoAddressIds = (
      await ManageAreaController.getGeoAddress(
        new ListGeoAddressApiRequest({
          pagination: new PaginationV2({
            limit: 99999
          })
        })
      )
    ).data;
  }

  setShiftValue(shift: any) {
    this.form.shifts = shift.map(
      (item: any) =>
        new DetailShifts({
          courierId: item.courierId,
          courierName: item.courierName,
          startTime: item.startTime,
          endTime: item.endTime
        })
    );
  }

  get disableButton() {
    const validateShift = this.isShiftEnabled
      ? this.isNotErrorShift
      : this.selectedCourier;
    return ![
      this.nameValidationError,
      this.form.geoAddressIds.length,
      validateShift
    ].every(Boolean);
  }

  async updateArea() {
    try {
      MainAppController.showLoading();
      await ManageAreaController.update({
        uid: this.form.uid,
        payload: new UpdatePartnerAreaRequest({
          areaName: this.form.areaName,
          geoAddressIds: this.form.geoAddressIds,
          shifts: this.isShiftEnabled
            ? this.form.shifts
            : [
                new DetailShifts({
                  courierId: this.selectedCourier.id,
                  startTime: "00:00",
                  endTime: "23:59"
                })
              ]
        })
      });
      this.visible = false;
      this.$emit("success");
    } catch (error) {
      this.$emit("error", error);
    } finally {
      MainAppController.closeLoading();
    }
  }

  get getShipmentType() {
    const shipment = [
      ...new Set(
        this.geoAddressIds
          .filter((ga) => this.form.geoAddressIds.includes(ga.geoAddressId))
          .map((ga) => ga.dedicatedShipment.split(", "))
          .flatMap((s) => s)
      )
    ];

    if (["Semua"].every((s) => shipment.includes(s))) return "Semua";
    if (
      ["Aggregator", "Customer", "Marketplace"].every((s) =>
        shipment.includes(s)
      )
    )
      return "Semua";
    if (["Aggregator", "Marketplace"].every((s) => shipment.includes(s)))
      return "Marketplace & Aggregator";
    if (["Aggregator", "Customer"].every((s) => shipment.includes(s)))
      return "Customer & Aggregator";
    if (["Marketplace", "Customer"].every((s) => shipment.includes(s)))
      return "Marketplace & Customer";

    return shipment.join(" & ");
  }
}
export default ModalEditArea;
